import React, { useEffect, useState } from "react";
import { client } from "@/lib/api";
import { Quote } from "lucide-react";

export default function ScriptureCard({ compact = false }) {
  const [verse, setVerse] = useState(null);

  useEffect(() => {
    client.get("/scripture/mine").then((r) => setVerse(r.data.verse)).catch(() => {});
  }, []);

  if (!verse) return null;

  return (
    <div
      data-testid="scripture-card"
      className={`relative overflow-hidden rounded-3xl bg-brand-navy-light text-brand-ivory border border-brand-gold/20 ${compact ? "p-6" : "p-8"} shadow-soft`}
    >
      <Quote className="absolute -top-2 -left-1 w-20 h-20 text-brand-gold/10" />
      <p className="uppercase tracking-[0.2em] text-[11px] text-brand-gold mb-3">Verse for today</p>
      <p className={`font-scripture italic leading-relaxed ${compact ? "text-scripture" : "text-scripture-lg"}`}>
        “{verse.text}”
      </p>
      <p className="mt-4 text-sm text-brand-ivory-muted">{verse.ref}</p>
    </div>
  );
}
